import React, { useState } from 'react'
import { Header } from 'components/Header'
import Footer from 'components/Footer'
import Box from 'components/base/Box'

const PageLayout = ({ children, viewer, loggedIn, hasFooter, hasUpgradeCta }) => {
  const [isNavBarOpen, setIsNavBarOpen] = useState(false)
  const onNavBarClick = () => setIsNavBarOpen(!isNavBarOpen)
  return (
    <>
      <Header
        loggedIn={loggedIn}
        viewer={viewer}
        show={isNavBarOpen}
        handleNavClick={onNavBarClick}
        showUpgradeCta={hasUpgradeCta}
      />
      {!isNavBarOpen && (
        <Box as='main' mt={{ _: '48px', desktop: '82px' }}>
          {children}
        </Box>
      )}
      {hasFooter && <Footer />}
    </>
  )
}

export default PageLayout
